require('./_set-species')('Array');



//////////////////
// WEBPACK FOOTER
// /usr/local/app/~/core-js/modules/es6.array.species.js
// module id = ../../../../core-js/modules/es6.array.species.js
// module chunks = 0